import { Outlet } from "react-router-dom";
import trailExpiredSvg from "@/assets/trailExpired.svg";
import { Phone } from "lucide-react";
import { useGlobalStore } from "@/GlobalStore";
import { Button } from "@/components/ui/button";

const TrialGuard = () => {
  const freeTrialExpired = useGlobalStore((state) => state.freeTrialExpired);
  if (!freeTrialExpired) {
    return <Outlet />;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full w-[40%] m-auto">
      <img src={trailExpiredSvg} />
      <div className="text-center font-medium text-[18px] leading-[100%] tracking-[0%] text-brand-primary-new">
        Trial's Up, What's Next?
      </div>
      <p className="text-center font-normal text-[16px] leading-[120%] tracking-[0%] text-[#617390] mt-4">
        Your free trial has ended, but your growth story is just beginning. Contact the
        Getcrux team or book a call below to keep momentum.
      </p>
      <Button
        className="h-8 bg-[#FF4500] hover:bg-[#FF4500CC] mt-6 flex items-center"
        onClick={() =>
          window.open("https://calendly.com/atharva-getcrux/30min", "_blank")
        }
      >
        <Phone size={14} className="text-[#FFFFFF] mr-2" />
        <span className="font-medium text-[12px] leading-[19.16px] tracking-[0.02em] text-white">
          Schedule Call
        </span>
      </Button>
    </div>
  );
};

export default TrialGuard;
